// extracted by mini-css-extract-plugin
module.exports = {"label":"ChangePasswordForm_label__2gyTD","input":"ChangePasswordForm_input__2YI0q"};